export var RewardCenterTabs = {
  OFFERS: 'offers',
  HISTORY: 'history',
  OFFER: 'offer',
  HISTORY_DETAIL: 'historyDetail',
  BACK: 'back',
  CATEGORIES: 'categories',
  HOME: 'home',
  PROFILE: 'profile'
};